import * as $ from 'jquery';
import lozad from 'lozad';
import { initTracker } from '../../../shared/js/tracker';
import { initShowcaseCore, initBackRedirect, readProductsBootstrap } from '../../../shared/js/showcase-core';
import { formatBankiRuTerm, initBankiRu } from '../../../shared/js/bankiru';
import { ready as apiReady } from '../../../shared/js/api-host';
import { trackGoal } from '../../../shared/js/metrika';

if (process.env.NODE_ENV === 'development') {
  import('../../../shared/mocks/setup');
}

import '../scss/style.scss';
import './components/marquee';
import './components/popup-forms';
import './components/inputmask';
import './components/fancybox';

const observer = lozad();
observer.observe();

$(function () {
  // ===== Синхронный блок: решаем, что показать, ДО любых сетевых запросов =====
  // Расшифровать Name:z5g/fullamount:z5g можно только на сервере (ключ шифрования
  // туда, в браузер, не отдаётся) — но сам факт «эти поля есть в ссылке» и галочка
  // «персонализированный заголовок» уже известны прямо сейчас, без похода в сеть.
  // Поэтому нужный вариант заголовка и блок «Выдача безработным» переключаем сразу,
  // а сетевой ответ (/api/visit/track) потом только подставляет готовый текст —
  // без визуального «сначала не то, потом то».
  const urlParams = new URLSearchParams(window.location.search);

  function isPersonalizedTitleAllowed() {
    const bootstrap = readProductsBootstrap();
    return Boolean(bootstrap && bootstrap.template && bootstrap.template.usePersonalizedTitle);
  }

  const expectsPersonalTitle = isPersonalizedTitleAllowed()
    && urlParams.has('Name:z5g')
    && urlParams.has('fullamount:z5g');
  const hasPh = urlParams.has('ph');

  const DEFAULT_TITLE_HTML = '<strong>Наши партнеры готовы выдать вам необходимую сумму!</strong>';
  const PERSONAL_TITLE_PLACEHOLDER_HTML =
    '<span style="font-weight: bold" data-field-name>Имя</span>, наши партнеры готовы выдать запрошенную сумму в '
    + '<span style="font-weight: bold" data-field-fullamount>50 000</span> руб. и более!';

  const $title = $('[data-title]');
  const $note = $('[data-unemployed-note]');

  if (expectsPersonalTitle) {
    // Персонализация ожидается: подменяем содержимое на разметку с местом под имя/сумму
    // ещё до ответа сети (плейсхолдер даёт строке правильный размер), саму строку
    // показываем только когда придут настоящие данные.
    $title.html(PERSONAL_TITLE_PLACEHOLDER_HTML);
  } else {
    // Обычный случай — содержимое уже верное (дефолтный текст), просто показываем.
    $title.css('visibility', 'visible');
  }

  if ($note.length) {
    if (hasPh || expectsPersonalTitle) $note.hide();
    else $note.show();
  }

  // ===== Асинхронный блок: только подставляет расшифрованный текст, видимость не трогает =====
  Promise.resolve(apiReady).then(() => {
    initShowcaseCore({
      clickSelector: '.tpl-offer__wrapper',
      template,
      showPreloader,
      hidePreloader,
    });

    function hasPersonalFields(fields) {
      return Boolean(
        fields
        && isPersonalizedTitleAllowed()
        && fields.name
        && typeof fields.fullamount === 'number'
        && !Number.isNaN(fields.fullamount)
      );
    }

    function applyPersonalizedTitle(fields) {
      const hasPersonal = hasPersonalFields(fields);

      if (!hasPersonal) {
        // Ожидали персонализацию (по галочке и параметрам в ссылке), но расшифровка
        // не удалась или сервер не прислал данные — возвращаем обычный текст.
        $title.html(DEFAULT_TITLE_HTML);
        $title.css('visibility', 'visible');
        if ($note.length && !hasPh) $note.show();
        return;
      }

      const formatAmount = (n) => (typeof n === 'number' ? n.toLocaleString('ru-RU').replace(/\s/g, '.') : String(n));
      $('[data-field-name]').text(String(fields.name));
      $('[data-field-fullamount]').text(formatAmount(fields.fullamount));
      // Место под строку уже зарезервировано (visibility:hidden) — теперь реально её показываем.
      $title.css('visibility', 'visible');
      if ($note.length) $note.hide();
    }

    // Apply immediately if data already present
    try {
      const fields = window.__visitData && window.__visitData.fields;
      if (fields) applyPersonalizedTitle(fields);
    } catch (_) {}

    // React to visit:tracked events
    window.addEventListener('visit:tracked', (e) => {
      const fields = e && e.detail && e.detail.fields;
      applyPersonalizedTitle(fields);
    });

    // Banki.ru integration — after visit/track so bankiRuInRollout is set
    initBankiRu({
      renderCard: bankiruRenderCard,
      wrapperOpen:
        '<div class="tpl-offers tpl-row tpl-align-horisontal-start tpl-js-offers-wrapper bankiru-offers__wrapper">',
      wrapperClose: '</div>',
    });
  });

  $(document)
    .off('click', '[data-scroll-to]')
    .on('click', '[data-scroll-to]', function (event) {
      event.preventDefault();

      const id = String($(this).attr('data-scroll-to') || '').trim();
      if (!id) return;

      const el = document.getElementById(id);
      if (!el) return;

      trackGoal('hero_cta_scroll_click', { target: id });
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
});

$(document).ready(function () {
  if ($('.tpl-marquee__init').length) {
    $('.tpl-marquee__init').marquee({
      delayBeforeStart: 0,
      duplicated: true,
      startVisible: true,
    });
  }
});

initBackRedirect();

function showPreloader(currLink) {
  $(currLink).css('pointer-events', 'none');
  $(currLink).find('.offer-button span').addClass('hide');
  $(currLink).find('.lds-ellipsis').removeClass('hide');
}

function hidePreloader(currLink) {
  $(currLink).css('pointer-events', 'auto');
  $(currLink).find('.offer-button span').removeClass('hide');
  $(currLink).find('.lds-ellipsis').addClass('hide');
}

function template(offer, num = '1') {
  return `
    <div
      class="tpl-offer__wrapper tpl-col-gutters tpl-js-clicked-offer"
      ${!offer.isBankiru ? `data-offer-id="${offer.id}"` : ''}
      ${offer.isBankiru && (offer.productId || offer.productCode) ? `data-product-id="${offer.productId || offer.productCode}"` : ''}
      ${offer.offerVisitId ? `data-offer-visit-id="${offer.offerVisitId}"` : ''}
    >
      <div class="tpl-offer tpl-sys-offer">
        ${num == '1' ? `<span class="tpl-offer__status">${offer.tag || getRandomTag()}</span>` : ''}
        <span class="tpl-offer__content">
          <span class="tpl-offer__information">
            <span class="tpl-offer__logo">
              <img src="${offer.image}" alt="" />
            </span>
          </span>
          ${offer.isBankiru ? `
            <span class="bankiru-card__details">
              <span class="bankiru-card__detail">
                <span class="bankiru-card__label">Сумма</span>
                <strong>${offer.amount?.toLocaleString('ru-RU') || 0} ₽</strong>
              </span>
              <span class="bankiru-card__detail">
                <span class="bankiru-card__label">Срок</span>
                <strong>${offer.termEnd || 0}</strong>
              </span>
            </span>
          ` : `
            <span class="tpl-offer__price--wrapper">
              <span class="tpl-offer__price">Доступно:<br />
                <span data-offer-unit="max.">${offer.amount?.toLocaleString('ru-RU') || 0} ₽</span>
              </span>
              <span class="tpl-offer__params">
                <span>${offer.isBankiru ? `Срок ${offer.termEnd || 0}` : `до ${offer.termEnd || 0} дней`}</span>
                ${offer.isBankiru ? '' : `<span>Первый заём ${offer.firstLoan || 'бесплатно'}</span>`}
              </span>
            </span>
          `}
          <button class="tpl-btn tpl-btn-wide offer-button ${offer.isBankiru ? 'bankiru-card__btn' : ''}">
            <span>${offer.isBankiru ? 'Получить одобренные деньги' : 'Получить деньги'}</span>
            <div class="lds-ellipsis hide">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </button>
        </span>
      </div>
      ${offer.expireHtml ? offer.expireHtml : ''}
    </div>
  `;
}

function getRandomTag() {
  const tags = ['Без справок', 'Первый займ - бесплатно', 'Без переплат'];
  return tags[Math.floor(Math.random() * tags.length)];
}

function bankiruRenderCard(p) {
  const term = formatBankiRuTerm(p.approvalTermMax, p.approvalTermTypeMax);
  const offer = {
    id: p.productCode,
    image: p.partnerLogo || '',
    amount: p.approvalAmountMax,
    termEnd: term,
    tag: '100% одобрение',
    firstLoan: '',
    isBankiru: true,
    productCode: p.productCode,
    productId: p.productId || p.productCode,
    expireHtml: p.approvalTermExpire
      ? `<div class=\"bankiru-card__expire\" data-expire=\"${p.approvalTermExpire}\"><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 6.5C5.90111 6.5 5.80444 6.47068 5.72221 6.41573C5.63999 6.36079 5.5759 6.2827 5.53806 6.19134C5.50022 6.09998 5.49031 5.99945 5.50961 5.90245C5.5289 5.80546 5.57652 5.71637 5.64645 5.64645C5.71637 5.57652 5.80546 5.5289 5.90245 5.50961C5.99945 5.49031 6.09998 5.50022 6.19134 5.53806C6.2827 5.5759 6.36079 5.63999 6.41573 5.72221C6.47068 5.80444 6.5 5.90111 6.5 6C6.5 6.13261 6.44732 6.25979 6.35355 6.35355C6.25979 6.44732 6.13261 6.5 6 6.5ZM10 9.5C9.90111 9.5 9.80444 9.52932 9.72221 9.58426C9.63999 9.63921 9.5759 9.7173 9.53806 9.80866C9.50022 9.90002 9.49031 10.0006 9.50961 10.0975C9.5289 10.1945 9.57652 10.2836 9.64645 10.3536C9.71637 10.4235 9.80546 10.4711 9.90245 10.4904C9.99944 10.5097 10.1 10.4998 10.1913 10.4619C10.2827 10.4241 10.3608 10.36 10.4157 10.2778C10.4707 10.1956 10.5 10.0989 10.5 10C10.5 9.86739 10.4473 9.74021 10.3536 9.64645C10.2598 9.55268 10.1326 9.5 10 9.5ZM15 8C15 8.6525 14.5306 9.14187 14.1163 9.57375C13.8806 9.82 13.6369 10.0737 13.545 10.2969C13.46 10.5013 13.455 10.84 13.45 11.1681C13.4406 11.7781 13.4306 12.4694 12.95 12.95C12.4694 13.4306 11.7781 13.4406 11.1681 13.45C10.84 13.455 10.5013 13.46 10.2969 13.545C10.0737 13.6369 9.82 13.8806 9.57375 14.1163C9.14187 14.5306 8.6525 15 8 15C7.3475 15 6.85812 14.5306 6.42625 14.1163C6.18 13.8806 5.92625 13.6369 5.70312 13.545C5.49875 13.46 5.16 13.455 4.83187 13.45C4.22187 13.4406 3.53062 13.4306 3.05 12.95C2.56937 12.4694 2.55937 11.7781 2.55 11.1681C2.545 10.84 2.54 10.5013 2.455 10.2969C2.36312 10.0737 2.11937 9.82 1.88375 9.57375C1.46937 9.14187 1 8.6525 1 8C1 7.3475 1.46937 6.85812 1.88375 6.42625C2.11937 6.18 2.36312 5.92625 2.455 5.70312C2.54 5.49875 2.545 5.16 2.55 4.83187C2.55937 4.22187 2.56937 3.53062 3.05 3.05C3.53062 2.56937 4.22187 2.55937 4.83187 2.55C5.16 2.545 5.49875 2.54 5.70312 2.455C5.92625 2.36312 6.18 2.11937 6.42625 1.88375C6.85812 1.46937 7.3475 1 8 1C8.6525 1 9.14187 1.46937 9.57375 1.88375C9.82 2.11937 10.0737 2.36312 10.2969 2.455C10.5013 2.54 10.84 2.545 11.1681 2.55C11.7781 2.55937 12.4694 2.56937 12.95 3.05C13.4306 3.53062 13.4406 4.22187 13.45 4.83187C13.455 5.16 13.46 5.49875 13.545 5.70312C13.6369 5.92625 13.8806 6.18 14.1163 6.42625C14.5306 6.85812 15 7.3475 15 8ZM6 7.5C6.29667 7.5 6.58668 7.41203 6.83336 7.2472C7.08003 7.08238 7.27229 6.84811 7.38582 6.57403C7.49935 6.29994 7.52906 5.99834 7.47118 5.70736C7.4133 5.41639 7.27044 5.14912 7.06066 4.93934C6.85088 4.72956 6.58361 4.5867 6.29264 4.52882C6.00166 4.47094 5.70006 4.50065 5.42597 4.61418C5.15189 4.72771 4.91762 4.91997 4.7528 5.16664C4.58797 5.41332 4.5 5.70333 4.5 6C4.5 6.39782 4.65804 6.77936 4.93934 7.06066C5.22064 7.34196 5.60218 7.5 6 7.5ZM10.8538 5.85375C10.9002 5.8073 10.9371 5.75214 10.9622 5.69145C10.9873 5.63075 11.0003 5.5657 11.0003 5.5C11.0003 5.4343 10.9873 5.36925 10.9622 5.30855C10.9371 5.24786 10.9002 5.1927 10.8538 5.14625C10.8073 5.09979 10.7521 5.06294 10.6914 5.0378C10.6308 5.01266 10.5657 4.99972 10.5 4.99972C10.4343 4.99972 10.3692 5.01266 10.3086 5.0378C10.2479 5.06294 10.1927 5.09979 10.1462 5.14625L5.14625 10.1462C5.09979 10.1927 5.06294 10.2479 5.0378 10.3086C5.01266 10.3692 4.99972 10.4343 4.99972 10.5C4.99972 10.5657 5.01266 10.6308 5.0378 10.6914C5.06294 10.7521 5.09979 10.8073 5.14625 10.8538C5.24007 10.9476 5.36732 11.0003 5.5 11.0003C5.5657 11.0003 5.63075 10.9873 5.69145 10.9622C5.75214 10.9371 5.8073 10.9002 5.85375 10.8538L10.8538 5.85375ZM11.5 10C11.5 9.70333 11.412 9.41332 11.2472 9.16665C11.0824 8.91997 10.8481 8.72771 10.574 8.61418C10.2999 8.50065 9.99834 8.47094 9.70736 8.52882C9.41639 8.5867 9.14912 8.72956 8.93934 8.93934C8.72956 9.14912 8.5867 9.41639 8.52882 9.70736C8.47094 9.99834 8.50065 10.2999 8.61418 10.574C8.72771 10.8481 8.91997 11.0824 9.16665 11.2472C9.41332 11.412 9.70333 11.5 10 11.5C10.3978 11.5 10.7794 11.342 11.0607 11.0607C11.342 10.7794 11.5 10.3978 11.5 10Z\" fill=\"white\"/></svg> Истекает через: <span class=\"bankiru-card__countdown\"></span></div>`
      : ''
  };
  return template(offer, '1');
}

initTracker();
